import { render, staticRenderFns } from "./MyAdmin.vue?vue&type=template&id=7fd8b0fc&scoped=true&"
import script from "./MyAdmin.vue?vue&type=script&lang=js&"
export * from "./MyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MyAdmin.vue?vue&type=style&index=0&id=7fd8b0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd8b0fc",
  null
  
)

export default component.exports